import car from './vehicles/default'
import truck from './vehicles/truck'
import motorcycle from './vehicles/motorcycle'
import pickup from './vehicles/pickup'
import bus from './vehicles/bus'
import van from './vehicles/van'
import tractor from './vehicles/tractor'
import boat from './vehicles/boat'
import bicycle from './vehicles/bicycle'
import offroad from './vehicles/offroad'
import trailer from './vehicles/trailer'
import scooter from './vehicles/scooter'
import tag from './vehicles/tag'
import {loadImage, prepareIcon} from "../mapUtil.js";
import {map} from "../MapView.jsx";
import {mapIcons} from "../preloadImages";
import backgroundSvg from "../../../resources/images/background.svg";
//const baseUrl = import.meta.env.PROD
//                  ? 'https://library.2ecomp.com/img/iconUber/iconsDinamicos_new_medidas'
//                  : '/icons3d';
const baseUrl = '/icons3d'
import { createTheme } from '@mui/material/styles';

export const icons = {
    default: car,
    car,
    truck,
    motorcycle,
    pickup,
    bus,
    van,
    tractor,
    boat,
    bicycle,
    offroad,
    trailer,
    scooter,
    tag,
}

// 2ECOMP: Desativado temporariamente para testar ícones locais convertidos
// Ícones não convertidos usarão fallback 2D até conversão completa
export const iconsRemote = {
    // crane: 'grua_60',         // TODO: converter para JS
    // trailer2: 'remolque_jaula', // TODO: converter para JS
    // plane: 'helicoptero_100',   // TODO: converter para JS
    // helicopter: 'helicoptero_100' // TODO: converter para JS
}

export function getSVG(iconPath, height=60, width=60, viewBox="0 0 50 50") {
    return `
        <svg preserveaspectratio="none" height="${height}" width="${width}" viewBox="${viewBox}" xmlns="http://www.w3.org/2000/svg">
            ${iconPath}
        </svg>
    `
}

const background = loadImage(backgroundSvg)
const imageCache = {}

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    info: {
      main: '#2196F3',  // Azul para dispositivos em movimento
    },
    success: {
      main: '#4caf50',  // Verde para online/parado
    },
    error: {
      main: '#f44336',  // Vermelho para offline
    },
  }
});

export default async (e, addToMap = true) => {
    if (!/^[a-z]+[0-9]?-[a-z]+-[0-9.]+$/.test(e.id)) {
        return;
    }
    if (map.getStyle() && map.hasImage(e.id)) {
        return;
    }
    // Parse the requested icon id to get color and rotation
    const [reqCategory, reqColor, reqRotation] = e.id.split('-');

    // Para ícones locais (car, truck, default), gerar imediatamente
    if (icons[reqCategory]) {
        // Adicionar placeholder transparente imediatamente para evitar erro do MapLibre
        if (map.getStyle() && addToMap && !map.hasImage(e.id)) {
            try {
                map.addImage(e.id, {
                    width: 1,
                    height: 1,
                    data: new Uint8Array([0, 0, 0, 0]),
                });
            } catch { /* ignore */ }
        }

        // Gerar o ícone correto
        if (!imageCache[e.id]) {
            const _color = reqColor === 'neutral'
                ? '#FE795D'
                : theme.palette[reqColor]?.main || '#FE795D';
            const svg = icons[reqCategory](reqRotation, _color, theme.palette);
            const svgBlob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
            imageCache[e.id] = await loadImage(URL.createObjectURL(svgBlob)).then(icon => prepareIcon(icon));
        }

        // Substituir placeholder pelo ícone real
        if (map.getStyle() && addToMap && imageCache[e.id]) {
            try {
                if (map.hasImage(e.id)) {
                    map.removeImage(e.id);
                }
                map.addImage(e.id, imageCache[e.id], { pixelRatio: window.devicePixelRatio });
            } catch { /* ignore */ }
        }
        return imageCache[e.id];
    }

    // Para ícones remotos, usar pixel transparente enquanto carrega (sem piscar)
    if (map.getStyle() && !map.hasImage(e.id)) {
        try {
            // Pixel 1x1 transparente - marker invisível até carregar
            map.addImage(e.id, {
                width: 1,
                height: 1,
                data: new Uint8Array([0, 0, 0, 0]),
            });
        } catch { /* ignore */ }
    }
    // Carregar ícone remoto ou fallback
    if (!imageCache[e.id]) {
        const [category, color, rotation] = e.id.split('-');
        const _color = color === 'neutral'
            ? '#FE795D'
            : theme.palette[color]?.main || '#FE795D';

        if (iconsRemote[category]) {
            // Ícone remoto: fetch HTTP
            const c = _color.replace('#', '');
            try {
                imageCache[e.id] = await loadImage(`${baseUrl}/${iconsRemote[category]}.php?grados=${rotation}&a=${c}&b=${c}&c=${c}`)
                    .then(icon => prepareIcon(icon));
            } catch (err) {
                // Fallback: usa o placeholder (já adicionado acima)
                return imageCache[e.id] = null;
            }
        } else {
            // Fallback para ícone 2D com background
            imageCache[e.id] = prepareIcon(await background, await loadImage(mapIcons[category]), _color);
        }
    }

    // Substituir placeholder pelo ícone real carregado
    if (map.getStyle() && addToMap && imageCache[e.id]) {
        try {
            if (map.hasImage(e.id)) {
                map.removeImage(e.id);
            }
            map.addImage(e.id, imageCache[e.id], { pixelRatio: window.devicePixelRatio });
        } catch (err) {
            // ignore
        }
    }

    return imageCache[e.id];
}